module.exports = __webpack_public_path__ + "static/media/showroom.47d33705.svg";